export * from './lib/truck-detail-layout.module';
export * from './lib/lib.routes';

export * from './lib/truck-detail/truck-detail.component';
